import { ɵgetAllInstancesOf, ɵgetDefaultInstanceOf, VERSION, ɵAngularFireSchedulers, ɵAppCheckInstances, ɵzoneWrap } from '@angular/fire';
import { from, timer } from 'rxjs';
import { concatMap, distinct } from 'rxjs/operators';
import * as i0 from '@angular/core';
import { InjectionToken, Optional, NgModule, NgZone, Injector } from '@angular/core';
import { FirebaseApp, FirebaseApps } from '@angular/fire/app';
import { registerVersion } from 'firebase/app';
import { authState as authState$1, user as user$1, idToken as idToken$1 } from 'rxfire/auth';
import { applyActionCode as applyActionCode$1, beforeAuthStateChanged as beforeAuthStateChanged$1, checkActionCode as checkActionCode$1, confirmPasswordReset as confirmPasswordReset$1, connectAuthEmulator as connectAuthEmulator$1, createUserWithEmailAndPassword as createUserWithEmailAndPassword$1, deleteUser as deleteUser$1, fetchSignInMethodsForEmail as fetchSignInMethodsForEmail$1, getAdditionalUserInfo as getAdditionalUserInfo$1, getAuth as getAuth$1, getIdToken as getIdToken$1, getIdTokenResult as getIdTokenResult$1, getMultiFactorResolver as getMultiFactorResolver$1, getRedirectResult as getRedirectResult$1, initializeAuth as initializeAuth$1, initializeRecaptchaConfig as initializeRecaptchaConfig$1, isSignInWithEmailLink as isSignInWithEmailLink$1, linkWithCredential as linkWithCredential$1, linkWithPhoneNumber as linkWithPhoneNumber$1, linkWithPopup as linkWithPopup$1, linkWithRedirect as linkWithRedirect$1, multiFactor as multiFactor$1, onAuthStateChanged as onAuthStateChanged$1, onIdTokenChanged as onIdTokenChanged$1, parseActionCodeURL as parseActionCodeURL$1, reauthenticateWithCredential as reauthenticateWithCredential$1, reauthenticateWithPhoneNumber as reauthenticateWithPhoneNumber$1, reauthenticateWithPopup as reauthenticateWithPopup$1, reauthenticateWithRedirect as reauthenticateWithRedirect$1, reload as reload$1, revokeAccessToken as revokeAccessToken$1, sendEmailVerification as sendEmailVerification$1, sendPasswordResetEmail as sendPasswordResetEmail$1, sendSignInLinkToEmail as sendSignInLinkToEmail$1, setPersistence as setPersistence$1, signInAnonymously as signInAnonymously$1, signInWithCredential as signInWithCredential$1, signInWithCustomToken as signInWithCustomToken$1, signInWithEmailAndPassword as signInWithEmailAndPassword$1, signInWithEmailLink as signInWithEmailLink$1, signInWithPhoneNumber as signInWithPhoneNumber$1, signInWithPopup as signInWithPopup$1, signInWithRedirect as signInWithRedirect$1, signOut as signOut$1, unlink as unlink$1, updateCurrentUser as updateCurrentUser$1, updateEmail as updateEmail$1, updatePassword as updatePassword$1, updatePhoneNumber as updatePhoneNumber$1, updateProfile as updateProfile$1, useDeviceLanguage as useDeviceLanguage$1, validatePassword as validatePassword$1, verifyBeforeUpdateEmail as verifyBeforeUpdateEmail$1, verifyPasswordResetCode as verifyPasswordResetCode$1 } from 'firebase/auth';
export * from 'firebase/auth';
const AUTH_PROVIDER_NAME = 'auth';
class Auth {
  constructor(auth) {
    return auth;
  }
}
class AuthInstances {
  constructor() {
    return ɵgetAllInstancesOf(AUTH_PROVIDER_NAME);
  }
}
const authInstance$ = /*#__PURE__*/ /*#__PURE__*/timer(0, 300).pipe( /*#__PURE__*/concatMap(() => from(ɵgetAllInstancesOf(AUTH_PROVIDER_NAME))), /*#__PURE__*/distinct());
const PROVIDED_AUTH_INSTANCES = /*#__PURE__*/new InjectionToken('angularfire2.auth-instances');
function defaultAuthInstanceFactory(provided, defaultApp) {
  const defaultAuth = ɵgetDefaultInstanceOf(AUTH_PROVIDER_NAME, provided, defaultApp);
  return defaultAuth && new Auth(defaultAuth);
}
function authInstanceFactory(fn) {
  return (zone, injector) => {
    const auth = zone.runOutsideAngular(() => fn(injector));
    return new Auth(auth);
  };
}
const AUTH_INSTANCES_PROVIDER = {
  provide: AuthInstances,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_AUTH_INSTANCES]]
};
const DEFAULT_AUTH_INSTANCE_PROVIDER = {
  provide: Auth,
  useFactory: defaultAuthInstanceFactory,
  deps: [[/*#__PURE__*/new Optional(), PROVIDED_AUTH_INSTANCES], FirebaseApp]
};
let AuthModule = /*#__PURE__*/(() => {
  class AuthModule {
    constructor() {
      registerVersion('angularfire', VERSION.full, 'auth');
    }
    static ɵfac = function AuthModule_Factory(t) {
      return new (t || AuthModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AuthModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [DEFAULT_AUTH_INSTANCE_PROVIDER, AUTH_INSTANCES_PROVIDER]
    });
  }
  return AuthModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function provideAuth(fn, ...deps) {
  return {
    ngModule: AuthModule,
    providers: [{
      provide: PROVIDED_AUTH_INSTANCES,
      useFactory: authInstanceFactory(fn),
      multi: true,
      deps: [NgZone, Injector, ɵAngularFireSchedulers, FirebaseApps, [new Optional(), ɵAppCheckInstances], ...deps]
    }]
  };
}

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const authState = /*#__PURE__*/ɵzoneWrap(authState$1, true);
const user = /*#__PURE__*/ɵzoneWrap(user$1, true);
const idToken = /*#__PURE__*/ɵzoneWrap(idToken$1, true);

// DO NOT MODIFY, this file is autogenerated by tools/build.ts
const applyActionCode = /*#__PURE__*/ɵzoneWrap(applyActionCode$1, true);
const beforeAuthStateChanged = /*#__PURE__*/ɵzoneWrap(beforeAuthStateChanged$1, true);
const checkActionCode = /*#__PURE__*/ɵzoneWrap(checkActionCode$1, true);
const confirmPasswordReset = /*#__PURE__*/ɵzoneWrap(confirmPasswordReset$1, true);
const connectAuthEmulator = /*#__PURE__*/ɵzoneWrap(connectAuthEmulator$1, true);
const createUserWithEmailAndPassword = /*#__PURE__*/ɵzoneWrap(createUserWithEmailAndPassword$1, true);
const deleteUser = /*#__PURE__*/ɵzoneWrap(deleteUser$1, true);
const fetchSignInMethodsForEmail = /*#__PURE__*/ɵzoneWrap(fetchSignInMethodsForEmail$1, true);
const getAdditionalUserInfo = /*#__PURE__*/ɵzoneWrap(getAdditionalUserInfo$1, true);
const getAuth = /*#__PURE__*/ɵzoneWrap(getAuth$1, true);
const getIdToken = /*#__PURE__*/ɵzoneWrap(getIdToken$1, true);
const getIdTokenResult = /*#__PURE__*/ɵzoneWrap(getIdTokenResult$1, true);
const getMultiFactorResolver = /*#__PURE__*/ɵzoneWrap(getMultiFactorResolver$1, true);
const getRedirectResult = /*#__PURE__*/ɵzoneWrap(getRedirectResult$1, true);
const initializeAuth = /*#__PURE__*/ɵzoneWrap(initializeAuth$1, true);
const initializeRecaptchaConfig = /*#__PURE__*/ɵzoneWrap(initializeRecaptchaConfig$1, true);
const isSignInWithEmailLink = /*#__PURE__*/ɵzoneWrap(isSignInWithEmailLink$1, true);
const linkWithCredential = /*#__PURE__*/ɵzoneWrap(linkWithCredential$1, true);
const linkWithPhoneNumber = /*#__PURE__*/ɵzoneWrap(linkWithPhoneNumber$1, true);
const linkWithPopup = /*#__PURE__*/ɵzoneWrap(linkWithPopup$1, true);
const linkWithRedirect = /*#__PURE__*/ɵzoneWrap(linkWithRedirect$1, true);
const multiFactor = /*#__PURE__*/ɵzoneWrap(multiFactor$1, true);
const onAuthStateChanged = /*#__PURE__*/ɵzoneWrap(onAuthStateChanged$1, true);
const onIdTokenChanged = /*#__PURE__*/ɵzoneWrap(onIdTokenChanged$1, true);
const parseActionCodeURL = /*#__PURE__*/ɵzoneWrap(parseActionCodeURL$1, true);
const reauthenticateWithCredential = /*#__PURE__*/ɵzoneWrap(reauthenticateWithCredential$1, true);
const reauthenticateWithPhoneNumber = /*#__PURE__*/ɵzoneWrap(reauthenticateWithPhoneNumber$1, true);
const reauthenticateWithPopup = /*#__PURE__*/ɵzoneWrap(reauthenticateWithPopup$1, true);
const reauthenticateWithRedirect = /*#__PURE__*/ɵzoneWrap(reauthenticateWithRedirect$1, true);
const reload = /*#__PURE__*/ɵzoneWrap(reload$1, true);
const revokeAccessToken = /*#__PURE__*/ɵzoneWrap(revokeAccessToken$1, true);
const sendEmailVerification = /*#__PURE__*/ɵzoneWrap(sendEmailVerification$1, true);
const sendPasswordResetEmail = /*#__PURE__*/ɵzoneWrap(sendPasswordResetEmail$1, true);
const sendSignInLinkToEmail = /*#__PURE__*/ɵzoneWrap(sendSignInLinkToEmail$1, true);
const setPersistence = /*#__PURE__*/ɵzoneWrap(setPersistence$1, true);
const signInAnonymously = /*#__PURE__*/ɵzoneWrap(signInAnonymously$1, true);
const signInWithCredential = /*#__PURE__*/ɵzoneWrap(signInWithCredential$1, true);
const signInWithCustomToken = /*#__PURE__*/ɵzoneWrap(signInWithCustomToken$1, true);
const signInWithEmailAndPassword = /*#__PURE__*/ɵzoneWrap(signInWithEmailAndPassword$1, true);
const signInWithEmailLink = /*#__PURE__*/ɵzoneWrap(signInWithEmailLink$1, true);
const signInWithPhoneNumber = /*#__PURE__*/ɵzoneWrap(signInWithPhoneNumber$1, true);
const signInWithPopup = /*#__PURE__*/ɵzoneWrap(signInWithPopup$1, true);
const signInWithRedirect = /*#__PURE__*/ɵzoneWrap(signInWithRedirect$1, true);
const signOut = /*#__PURE__*/ɵzoneWrap(signOut$1, true);
const unlink = /*#__PURE__*/ɵzoneWrap(unlink$1, true);
const updateCurrentUser = /*#__PURE__*/ɵzoneWrap(updateCurrentUser$1, true);
const updateEmail = /*#__PURE__*/ɵzoneWrap(updateEmail$1, true);
const updatePassword = /*#__PURE__*/ɵzoneWrap(updatePassword$1, true);
const updatePhoneNumber = /*#__PURE__*/ɵzoneWrap(updatePhoneNumber$1, true);
const updateProfile = /*#__PURE__*/ɵzoneWrap(updateProfile$1, true);
const useDeviceLanguage = /*#__PURE__*/ɵzoneWrap(useDeviceLanguage$1, true);
const validatePassword = /*#__PURE__*/ɵzoneWrap(validatePassword$1, true);
const verifyBeforeUpdateEmail = /*#__PURE__*/ɵzoneWrap(verifyBeforeUpdateEmail$1, true);
const verifyPasswordResetCode = /*#__PURE__*/ɵzoneWrap(verifyPasswordResetCode$1, true);

/**
 * Generated bundle index. Do not edit.
 */

export { Auth, AuthInstances, AuthModule, applyActionCode, authInstance$, authState, beforeAuthStateChanged, checkActionCode, confirmPasswordReset, connectAuthEmulator, createUserWithEmailAndPassword, deleteUser, fetchSignInMethodsForEmail, getAdditionalUserInfo, getAuth, getIdToken, getIdTokenResult, getMultiFactorResolver, getRedirectResult, idToken, initializeAuth, initializeRecaptchaConfig, isSignInWithEmailLink, linkWithCredential, linkWithPhoneNumber, linkWithPopup, linkWithRedirect, multiFactor, onAuthStateChanged, onIdTokenChanged, parseActionCodeURL, provideAuth, reauthenticateWithCredential, reauthenticateWithPhoneNumber, reauthenticateWithPopup, reauthenticateWithRedirect, reload, revokeAccessToken, sendEmailVerification, sendPasswordResetEmail, sendSignInLinkToEmail, setPersistence, signInAnonymously, signInWithCredential, signInWithCustomToken, signInWithEmailAndPassword, signInWithEmailLink, signInWithPhoneNumber, signInWithPopup, signInWithRedirect, signOut, unlink, updateCurrentUser, updateEmail, updatePassword, updatePhoneNumber, updateProfile, useDeviceLanguage, user, validatePassword, verifyBeforeUpdateEmail, verifyPasswordResetCode };
